module.exports = __webpack_public_path__ + "img/map_Z2.2.B.02.4aff6f3c.svg";